import { Popover as P } from 'radix-ui';
import type { ReactElement, ReactNode } from 'react';
import { cx } from '@/lib/cx';
import s from './Popover.module.css';

export function Popover({
  trigger,
  children,
  open,
  onOpenChange,
  align = 'start',
  side = 'bottom',
  width = 'auto',
  className,
  label,
}: {
  trigger: ReactElement;
  children: ReactNode;
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
  align?: 'start' | 'center' | 'end';
  side?: 'top' | 'right' | 'bottom' | 'left';
  width?: 'auto' | 'sm' | 'md' | 'lg';
  className?: string;
  /** Accessible name for the dialog. */
  label?: string;
}) {
  return (
    <P.Root open={open} onOpenChange={onOpenChange}>
      <P.Trigger asChild>{trigger}</P.Trigger>
      <P.Portal>
        <P.Content align={align} side={side} sideOffset={6} collisionPadding={8} className={cx(s.content, s[width], className)} aria-label={label}>
          {children}
        </P.Content>
      </P.Portal>
    </P.Root>
  );
}

export const PopoverClose = P.Close;
